export default __webpack_public_path__ + "static/img5-b3fd5f4e97ec80d59690f34694fc0754.png";